import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BUSY_MODE_KEYS } from '../../../config/constants/analytics';
import { isEmpty } from '../../../utils';
import * as selectors from '../selectors';
import AnalyticsHeatmapContainer from './AnalyticsHeatmapContainer';

const BusyModeHeatmapChart = ({
  analyticsDataLoading,
  analyticsData,
  selectedTimePeriod,
  isComparisonEnabled,
}) => {
  const renderChart = (
    <AnalyticsHeatmapContainer
      analyticsData={
        !isEmpty(analyticsData?.analytics) ? analyticsData.analytics : []
      }
      analyticsDataLoading={analyticsDataLoading}
      selectedTimePeriod={selectedTimePeriod}
      targetKey={BUSY_MODE_KEYS.BUSY_MINUTES}
      seriesName="Realized Revenue"
      isComparisonEnabled={isComparisonEnabled}
    />
  );
  return <div className="flex flex-col p-4 h-full">{renderChart}</div>;
};
BusyModeHeatmapChart.propTypes = {
  analyticsData: PropTypes.any,
  analyticsDataLoading: PropTypes.bool,
  selectedTimePeriod: PropTypes.string,
  isComparisonEnabled: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  isComparisonEnabled: selectors.makeSelectProperty('selectedComparisonType'),
  analyticsDataLoading: selectors.makeSelectBusyModeAnalyticsDataLoading(),
  analyticsData: selectors.makeSelectBusyModeAnalyticsData(),
  selectedTimePeriod: selectors.makeSelectTimePeriodSlug(),
});

const withConnect = connect(mapStateToProps);
export default compose(withConnect)(BusyModeHeatmapChart);
